/** 是否为「自动匹配当前域名」的配置值 */
function isAutoBaseUrl(envUrl) {
  const v = (envUrl || "").trim();
  return !v || v === "/" || v === "./";
}

/**
 * 应用 API 根前缀（含末尾 /）
 * - .env 配置完整 URL 时使用该地址（开发环境、前后端不同域）
 * - 未配置或为 / 时，运行时取 window.location.origin
 */
export function getAppBaseUrl() {
  const envUrl = process.env.VUE_APP_BASE_URL;
  if (!isAutoBaseUrl(envUrl)) {
    const normalized = String(envUrl).trim();
    return normalized.endsWith("/") ? normalized : `${normalized}/`;
  }
  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}/`;
  }
  return "/";
}

/** 业务接口前缀，默认 {baseUrl}yxjl */
export function getApiBaseUrl() {
  return `${getAppBaseUrl()}yxjl`;
}

/** 文件上传等需要完整地址的场景 */
export function getUploadBaseUrl() {
  return `${getApiBaseUrl()}/sys/oss/upload`;
}
